
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";
import { FaThumbsUp, FaThumbsDown  } from "react-icons/fa";

// import Select from 'react-select';

const ApproveFeeWaiver = () => {

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      irn: '',
      year1: '',
      section_id: '',
      gr_no: '',
      stud_name: '',
      fw_id: '',
      fw_desc: '',
      std_div: '',
      fw_remarks: '',
      waiver_amt: '',
    }
  ]);

  useEffect(() => {
    const fetchLists = async () => {
      try {

        retrieveAllocFW();

      } catch (err) {
        console.error("Data fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const retrieveAllocFW = async () => {

    try {

      const result = await axios.get(`${BASE_URL}/api/get_alloc_fw_appr`);

      if (result.data.length > 0) {
        setChildRows(result.data);
      } else {
        //setChildRows([{ irn: '', year1: '', section_id: '', gr_no: '', stud_name: '', fw_id: '', fw_desc: '', std_div: '', }]);
        setChildRows([]);
      }

    } catch (error) {
      toast.error('Error in Approval. ' + error);
    }

  }

  const handleApprove = async (index) => {

    const studentName = childRows[index]?.stud_name;
    const fwDesc = childRows[index]?.fw_desc;

    const isConfirmed = window.confirm(`Approve the Fees Waiver, ${fwDesc}, for Student, ${studentName}`);

    if (!isConfirmed) return;

    const irn = childRows[index]?.irn;
    const year1 = childRows[index]?.year1;
    const sectionId = childRows[index]?.section_id;
    const grNo = childRows[index]?.gr_no;
    const fwId = childRows[index]?.fw_id;

    try {

      const response = await axios.post(`${BASE_URL}/api/appr_rej_fw_alloc`,
        { params: { p_Status: 'APPR', p_Year1: year1, p_Section_Id: sectionId, p_GR_No: grNo, p_irn: irn, p_fw_Id: fwId } });

      if (response.data.message === '1') {
        setChildRows([]);
        toast.success('Fee Waiver Approved successfully.');
        retrieveAllocFW();
      } else {
        toast.error('Unable tp Approve Fee Waiver.');
      }

    } catch (error) {
      toast.error('Error in Approval. ' + error);
    }

  };

  const handleReject = async (index) => {

    const studentName = childRows[index]?.stud_name;
    const fwDesc = childRows[index]?.fw_desc;

    const isConfirmed = window.confirm(`Reject the Fees Waiver, ${fwDesc}, for Student, ${studentName}`  );

    if (!isConfirmed) return;

    const irn = childRows[index]?.irn;
    const year1 = childRows[index]?.year1;
    const sectionId = childRows[index]?.section_id;
    const grNo = childRows[index]?.gr_no;
    const fwId = childRows[index]?.fw_id;

    const response = await axios.post(`${BASE_URL}/api/appr_rej_fw_alloc`, 
      {params : {p_Status: 'REJ', p_Year1: year1, p_Section_Id: sectionId, p_GR_No: grNo, p_irn: irn, p_fw_Id:fwId}});

    if (response.data.message === '1') {
      setChildRows([]);
      toast.error('Fee Waiver Rejected successfully.');
      retrieveAllocFW();
    }

  };

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const handleRefresh = () => {
    setChildRows([]);
    retrieveAllocFW();
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleRefresh}
          > Refresh
          </button>

        </div>
      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '27%', textAlign: 'left' }}>Student Name</th>
                <th style={{ width: '9%', textAlign: 'left' }}>Std/Div</th>
                <th style={{ width: '18%', textAlign: 'left' }}>Allocated Fee Waiver</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Waiver Amt</th>
                <th style={{ width: '26%', textAlign: 'left' }}>Remarks</th>
                <th style={{ width: '5%', textAlign: 'center' }}></th>
                <th style={{ width: '5%', textAlign: 'center' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "4%", textAlign: 'center' }}>{index + 1}</td>
                  <td>{row.stud_name} </td>
                  <td>{row.std_div} </td>
                  <td> {row.fw_desc} </td>
                  <td style={{ textAlign: 'right' }}> {formatAmount(row.waiver_amt)} </td>
                  <td> {row.fw_remarks} </td>

                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-approve-${index}`} >Approve</Tooltip>} >
                      <span className="d-inline-block">
                        <Button disabled={childRows.length === 0} variant="success" onClick={() => handleApprove(index)} >
                          <FaThumbsUp style={{ marginRight: "5px" }} /> </Button>
                        {/* Approve */}
                      </span>
                    </OverlayTrigger>
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id={`tooltip-approve-${index}`} >Reject</Tooltip>}>
                      <span className="d-inline-block">
                        <Button disabled={childRows.length === 0} variant="danger" onClick={() => handleReject(index)} >
                          <FaThumbsDown style={{ marginRight: "5px" }} /> </Button>
                        {/* Reject */}
                      </span>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default ApproveFeeWaiver;
